<app-ui-document-panel-shell
  [breadcrumb]="breadcrumb"
  [title]="panelTitle"
  [documentId]="voucherNo || ''"
  [statusLabel]="statusLabel"
  [statusVariant]="statusVariant"
  (closed)="onClose()">

  <div class="voucher-panel">
    <app-ui-approval-stepper [steps]="approvalSteps"></app-ui-approval-stepper>

    <app-ui-form-section title="General Information" icon="info">
      <div class="voucher-panel__field-grid">
        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>Voucher Type<span class="ui-doc-panel-content__required">*</span></mat-label>
            <mat-select [(ngModel)]="voucherType" #dataRef (ngModelChange)="fetchvouchertype(dataRef.value);"
              placeholder="Select Voucher Type" [disabled]="isUpdate || !!voucherType || isInputDisabled">
              <mat-option *ngFor="let item of vouchers" [value]="item.id">{{ item.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>Invoice Type<span class="ui-doc-panel-content__required">*</span></mat-label>
            <mat-select [(ngModel)]="invoice_type" placeholder="Select invoice type" [disabled]="isUpdate || isInputDisabled">
              <mat-option value="sales">Sales Voucher</mat-option>
              <mat-option value="purchase">Purchase Voucher</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>Branch<span class="ui-doc-panel-content__required">*</span></mat-label>
            <mat-select [(ngModel)]="branch" #branch_id
              (ngModelChange)="onBranchChangeWithLedger(branch_id.value)" placeholder="Select Branch"
              [disabled]="isUpdate || isInputDisabled">
              <mat-option *ngFor="let type of branchdata" [value]="type.id">{{ type.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field" *ngIf="invoice_type == 'purchase'">
          <mat-form-field appearance="outline">
            <mat-label>Purchase Invoice<span class="ui-doc-panel-content__required">*</span></mat-label>
            <mat-select [(ngModel)]="purchaseInvoice" placeholder="Select Purchase Invoice"
              (ngModelChange)="fetchdocuments();fetchProfitCostFromInvoice(invoice_type, purchaseInvoice)"
              [disabled]="isUpdate || isInputDisabled">
              <mat-option *ngFor="let item of purchase_invoice" [value]="item.id">{{ item.voucher_no }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field" *ngIf="invoice_type == 'sales'">
          <mat-form-field appearance="outline">
            <mat-label>Sales Invoice<span class="ui-doc-panel-content__required">*</span></mat-label>
            <mat-select [(ngModel)]="salesInvoice" placeholder="Select Sales Invoice"
              (ngModelChange)="fetchdocuments();fetchProfitCostFromInvoice(invoice_type, salesInvoice)"
              [disabled]="isUpdate || isInputDisabled">
              <mat-option *ngFor="let item of sales_invoice" [value]="item.id">{{ item.voucher_no }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field" *ngIf="invoice_type == 'sales'">
          <mat-form-field appearance="outline">
            <mat-label>Sales Return</mat-label>
            <mat-select [(ngModel)]="document" placeholder="Select Sales Return"
              (ngModelChange)="documentDetails()" [disabled]="isUpdate || isInputDisabled">
              <mat-option *ngFor="let item of documents" [value]="item.id">{{ item.voucher_no }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field" *ngIf="invoice_type == 'purchase'">
          <mat-form-field appearance="outline">
            <mat-label>GSRN<span class="ui-doc-panel-content__required">*</span></mat-label>
            <mat-select [(ngModel)]="document" placeholder="Select GSRN" [disabled]="isUpdate || isInputDisabled">
              <mat-option *ngFor="let item of documents" [value]="item.id">{{ item.grn_no }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>Profit Cost<span class="ui-doc-panel-content__required">*</span></mat-label>
            <mat-select [(ngModel)]="profit_cost_id" placeholder="Select Profit Cost"
              (ngModelChange)="onProfitCost($event)" [disabled]="isUpdate || isInputDisabled" multiple>
              <mat-option *ngFor="let profitcost of profit_cost" [value]="profitcost.id">
                {{ profitcost.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field" *ngIf="invoice_type == 'sales'">
          <mat-form-field appearance="outline">
            <mat-label>Customer Name</mat-label>
            <input matInput [(ngModel)]="customers" placeholder="Customer" disabled>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field" *ngIf="invoice_type == 'sales'">
          <mat-form-field appearance="outline">
            <mat-label>Customer Branch</mat-label>
            <input matInput [(ngModel)]="cutomer_branchs" placeholder="Customer Branch" disabled>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field" *ngIf="invoice_type == 'purchase'">
          <mat-form-field appearance="outline">
            <mat-label>Vendor Name</mat-label>
            <input matInput [(ngModel)]="vendors" placeholder="Vendor" disabled>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field" *ngIf="invoice_type == 'purchase'">
          <mat-form-field appearance="outline">
            <mat-label>Vendor Branch</mat-label>
            <input matInput [(ngModel)]="vendor_branchs" placeholder="Vendor Branch" disabled>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>Invoice Date</mat-label>
            <input type="date" matInput [(ngModel)]="invoice_date" [max]="maxDate" disabled>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>Date<span class="ui-doc-panel-content__required">*</span></mat-label>
            <input type="date" matInput [(ngModel)]="date" [attr.min]="invoice_date || null" [max]="maxDate"
              [disabled]="isInputDisabled">
          </mat-form-field>
        </div>
      </div>
    </app-ui-form-section>

    <app-ui-form-section *ngIf="voucher_type == 'Credit Note' && invoice_type == 'sales'" title="Line Items" icon="view_list">
      <p class="ui-doc-panel-table-hint">Scroll inside the table area to view all columns and rows.</p>
      <div class="ui-doc-panel-table-scroll" *ngIf="salesInvoice">
        <table class="product-table ui-doc-line-table">
          <thead>
            <tr>
              <th>Profit/Cost</th>
              <th>Section</th>
              <th>Item/Service Name</th>
              <th>HSN/SAC No</th>
              <th>Description</th>
              <th>UOM</th>
              <th>Unit Price</th>
              <th>Quantity</th>
              <th>Value</th>
              <th>Discount</th>
              <th>Incentive</th>
              <th>GST %</th>
              <th>Change Quantity</th>
              <th>Change Value</th>
              <th>Final discount</th>
              <th>Final incentive</th>
              <th>Final Value</th>
              <th>CGST</th>
              <th>SGST</th>
              <th>IGST</th>
              <th>Total GST Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of sales_invoice_details; let i = index">
              <td>{{ entry?.profit_cost_name }}</td>
              <td>{{ entry?.section_name }}</td>
              <td class="ui-doc-line-table__wrap">{{ entry?.name }}</td>
              <td>{{ entry?.hsn_no }}</td>
              <td class="ui-doc-line-table__wrap">{{ entry?.description }}</td>
              <td>{{ entry?.unit_name }}</td>
              <td>{{ entry?.unit_price | number:'1.2-2' }}</td>
              <td>{{ entry?.qty | number:'1.3-3' }}</td>
              <td>{{ entry?.qty * entry?.unit_price | number:'1.2-2' }}</td>
              <td>{{ entry?.discount_amount | number:'1.2-2' }}</td>
              <td>{{ entry?.incentive_amount | number:'1.2-2' }}</td>
              <td>{{ entry?.gst_percentage | number:'1.2-2' }}</td>
              <td>{{ entry?.change_qty | number:'1.3-3' }}</td>
              <td>
                <input type="number" [(ngModel)]="entry.change_value"
                  (ngModelChange)="PriceChange(entry, entry.qty, entry.change_value)" min="0.01" step="0.01"
                  [disabled]="entry.is_affect_qty == 1 || isInputDisabled" />
              </td>
              <td>{{ finaldiscount(entry) | number:'1.2-2' }}</td>
              <td>{{ finalincentive(entry) | number:'1.2-2' }}</td>
              <td>{{ ((entry.change_value || 0) - (entry.final_discount || 0) + (entry.final_incentive || 0)) | number:'1.2-2' }}</td>
              <td>{{ lineItemCgstAmount(entry) | number:'1.2-2' }}
                <span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage / 2 }}%)</span>
              </td>
              <td>{{ lineItemSgstAmount(entry) | number:'1.2-2' }}
                <span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage / 2 }}%)</span>
              </td>
              <td>{{ lineItemIgstAmount(entry) | number:'1.2-2' }}
                <span *ngIf="gstMatch() === false && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage }}%)</span>
              </td>
              <td>{{ lineItemTotalGstAmount(entry) | number:'1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </app-ui-form-section>

    <app-ui-form-section *ngIf="voucher_type == 'Credit Note' && invoice_type == 'purchase'" title="Line Items" icon="view_list">
      <p class="ui-doc-panel-table-hint">Scroll inside the table area to view all columns and rows.</p>
      <div class="ui-doc-panel-table-scroll">
        <table class="product-table ui-doc-line-table">
          <thead>
            <tr>
              <th>Profit/Cost</th>
              <th>Section</th>
              <th>Item/Service Name</th>
              <th>HSN/SAC No</th>
              <th>Description</th>
              <th>UOM</th>
              <th>Unit Price</th>
              <th>Quantity</th>
              <th>Value</th>
              <th>GST %</th>
              <th>CGST</th>
              <th>SGST</th>
              <th>IGST</th>
              <th>Total GST Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of debit_note_details; let i = index">
              <td>{{ entry?.profit_cost_name }}</td>
              <td>{{ entry?.section_name }}</td>
              <td class="ui-doc-line-table__wrap">{{ entry?.name }}</td>
              <td>{{ entry?.hsn_no }}</td>
              <td class="ui-doc-line-table__wrap">{{ entry?.description }}</td>
              <td>{{ entry?.unit_name }}</td>
              <td>{{ entry?.unit_price | number:'1.2-2' }}</td>
              <td>{{ entry?.qty | number:'1.3-3' }}</td>
              <td>{{ (entry?.qty * entry?.unit_price) | number:'1.2-2' }}</td>
              <td>{{ entry?.gst_percentage | number:'1.2-2' }}</td>
              <td>{{ lineItemCgstAmount(entry) | number:'1.2-2' }}
                <span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage / 2 }}%)</span>
              </td>
              <td>{{ lineItemSgstAmount(entry) | number:'1.2-2' }}
                <span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage / 2 }}%)</span>
              </td>
              <td>{{ lineItemIgstAmount(entry) | number:'1.2-2' }}
                <span *ngIf="gstMatch() === false && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage }}%)</span>
              </td>
              <td>{{ lineItemTotalGstAmount(entry) | number:'1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </app-ui-form-section>

    <div class="voucher-panel__bottom" *ngIf="invoice_type">
      <div class="voucher-panel__bottom-left">
        <app-ui-form-section title="Approval Details" icon="verified">
          <mat-form-field appearance="outline" class="voucher-panel__narration">
            <mat-label>Narration<span class="ui-doc-panel-content__required">*</span></mat-label>
            <textarea matInput [(ngModel)]="narration" placeholder="Enter narration..." rows="4"
              [disabled]="data.approval_status === 'Pending' || isInputDisabled"></textarea>
          </mat-form-field>
        </app-ui-form-section>

        <app-ui-form-section title="Attachments" icon="attach_file">
          <app-ui-document-file-upload
            [disabled]="isInputDisabled"
            [files]="myFiles"
            [showViewLink]="!!data?.id && operationType !== 'create'"
            (filesSelected)="onFileSelected($event)"
            (removeFile)="removeFile($event)"
            (viewFiles)="openFileShowModal()">
          </app-ui-document-file-upload>
        </app-ui-form-section>
      </div>

      <aside class="voucher-panel__summary">
        <ng-container *ngIf="activeLineItems.length > 0; else emptySummary">
          <div class="voucher-panel__summary-row">
            <span>Sub Total GST</span>
            <span class="voucher-panel__summary-value">{{ getTotalGSTForDetails(activeLineItems) | number:'1.2-2' }}</span>
          </div>
          <div class="voucher-panel__summary-divider"></div>
          <div class="voucher-panel__summary-grand-label">GST Total</div>
          <div class="voucher-panel__summary-grand">{{ getTotalGSTForDetails(activeLineItems) | number:'1.2-2' }}</div>
        </ng-container>
        <ng-template #emptySummary>
          <div class="voucher-panel__summary-empty">Totals appear after line items are loaded.</div>
        </ng-template>
      </aside>
    </div>
  </div>

  <app-ui-document-panel-footer
    [primaryActions]="footerPrimaryActions"
    [secondaryActions]="footerSecondaryActions"
    [destructiveAction]="footerDestructiveAction"
    [overflowActions]="footerOverflowActions"
    (actionClick)="onFooterAction($event)">
  </app-ui-document-panel-footer>
</app-ui-document-panel-shell>
